import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, VisitorTrackerFullDTO } from '../../../../services/api/api';
import { UtilService } from '../../../../services/util.service';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../../services/error.service';
import { NavigationService } from '@ngx-seatback/utils';
import { PermissionService } from '../../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-tracker-details-overview',
  templateUrl: './tracker-details-overview.component.html',
  styleUrls: ['./tracker-details-overview.component.scss'],
  standalone: false,
})
export class TrackerDetailsOverviewComponent implements OnInit {
  tracker: VisitorTrackerFullDTO;
  trackerId: number;
  loading: boolean;

  constructor(
    public util: UtilService,
    private api: API,
    private activatedRoute: ActivatedRoute,
    public errorHandler: ErrorService,
    private navService: NavigationService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.tracker = undefined;
    this.trackerId = undefined;
    this.loading = true;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.trackerId = +params.trackerID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .dm_visitor_VisitorTracker_retrieveById(this.trackerId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (tracker: VisitorTrackerFullDTO) => {
          this.tracker = tracker;
          this.loading = false;
        },
        error: error => {
          if (error.status && (+error.status === 403 || +error.status === 404)) {
            this.navService.navigateToPoint(this.util.RoutingID.tracker);
          } else {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }
}
